import Header from '../components/Header';
import {Box} from '@mui/material';
import styles from '../styles';
import {useLocation} from 'react-router-dom';
import BookingPaymentSummaryComponent from './BookingPaymentSummaryComponent';

export default function BookingPaymentSummary() {
  const location = useLocation();
  const paymentSuccessData = location?.state?.paymentSuccessData;

  return (
    <Box sx={styles.wrapper}>
      <Header />
      <BookingPaymentSummaryComponent paymentSuccessData={paymentSuccessData} />
    </Box>
  );
}
